import type { FC, ReactNode } from 'react';
import { QBox, QBoxProps } from '../../QLayouts';

export interface QDrawerFooterProps extends QBoxProps {
  children: ReactNode;
}

export const QDrawerFooter: FC<QDrawerFooterProps> = ({
  children,
  ...props
}) => {
  return <QBox {...props}>{children}</QBox>;
};

QDrawerFooter.displayName = 'QDrawerFooter';
